var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4F2FF",
    d: "M7.498 8a5.25 5.25 0 0 1 10.334-1.313.75.75 0 0 0 1.453-.374A6.75 6.75 0 0 0 5.998 8v2.055c-1.115.083-1.841.293-2.372.824-.878.878-.878 2.293-.878 5.121s0 4.243.878 5.121C4.505 22 5.92 22 8.748 22h8c2.828 0 4.242 0 5.12-.879.88-.878.88-2.293.88-5.121s0-4.243-.88-5.121C20.99 10 19.577 10 16.749 10h-8q-.677-.001-1.25.004z"
  })));
};
export default SvgLock;